import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c84a9082")

_pushScopeId("data-v-c84a9082")
const _hoisted_1 = { class: "toast-message-container" }
const _hoisted_2 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.messages, (item) => {
      return (_openBlock(), _createBlock(_Transition, {
        key: item.id,
        name: "fade"
      }, {
        default: _withId(() => [
          (item.isShow)
            ? (_openBlock(), _createBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs, {
                class: ["toast-message mb-2 flex justify-between", [item.type]]
              }), [
                _createVNode("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "default", {}, () => [
                    _createTextVNode(_toDisplayString(item.message), 1)
                  ], {}, true)
                ]),
                _createVNode("span", {
                  class: "cp-icon-close-circle cursor-pointer",
                  onClick: ($event: any) => (_ctx.hide(item))
                }, null, 8, ["onClick"])
              ], 16))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
})